import React, {PureComponent} from 'react';
import {Modal} from 'react-responsive-modal';
import {withTranslation} from "react-i18next";
import {subscribeClock} from "../functions/api";


class SeatTimeAlertModal extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
            now: new Date().getTime(),
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        subscribeClock((obj) => {
            this.setState({
                now: obj.tim,
            });
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.seatTimeSum !== this.props.seatTimeSum) {
            if (this.props.sessionActive === '2' && this.props.seatTimeLastTimestamp > 0 && this.props.startTimestamp > 0) {
                clearInterval(this.seatAlertInterval);
                this.seatAlertInterval = setInterval(() => {
                    const now = this.state.now;
                    const currentShift = Math.abs(this.props.seatTimeLastTimestamp - now);
                    let seatTime = (this.props.seatTimeSum + currentShift);
                    if (seatTime >= (this.props.seatTimeLimitAlert * 60 * 1000)) {
                        this.openModal();
                        clearInterval(this.seatAlertInterval);
                    }
                }, 1000);
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.seatAlertInterval);
        subscribeClock(null);
    }

    openModal() {
        this.setState({
            modalOpen: true,
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false,
        });
    }

    render() {
        return (
            <section>
                <Modal open={this.state.modalOpen}
                       onClose={() => {
                       }}
                       animationDuration={200}
                       center={true}
                       classNames={{modal: "medium-modal fadeInLeft"}}
                       showCloseIcon={false}
                >
                    <div className={"row"}>
                        <div className={"col-sm-12"}>
                            <h3 className={"text-center"}><b className={"App_header"} style={{color: "#ff1200"}}>{this.props.t("seatTimeAlertModalTitle")}!</b></h3>
                        </div>
                        <div className={"col-sm-12 text-center"} style={{paddingLeft: 35, paddingRight: 35}}>
                            <h2 className={"App_teamTitle"} style={{color: "#000000"}}><b>{this.props.driverName.toUpperCase()}</b> {this.props.t("seatTimeAlertModalText_1")} <b>{this.props.seatTimeLimitAlert}</b> {this.props.t("seatTimeAlertModalText_2")}</h2>
                        </div>
                        <div className={"col-sm-12 text-center"} style={{padding: 20}}>
                            <button
                                className={"btn App_white_text button"}
                                style={{background: "#ff0003", color: "#FFFFFF"}}
                                onClick={this.closeModal}
                            >{this.props.t("ok")}
                            </button>
                        </div>
                    </div>
                </Modal>
            </section>
        );
    }
}

export default withTranslation("translations")(SeatTimeAlertModal);
